import { render, staticRenderFns } from "./ScaleWeight.vue?vue&type=template&id=266c2ee4&scoped=true&"
import script from "./ScaleWeight.vue?vue&type=script&lang=js&"
export * from "./ScaleWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266c2ee4",
  null
  
)

export default component.exports